import React from "react";
import { inject, observer } from "mobx-react";
import { CHANGE_TABLE_CELL_EVENT } from "../../../../constants/events";
import Checkbox from "components/tables/columns/checkbox";

interface Props {
  checked: boolean;
  entityKey: string;
  entityId: unknown;
  disabled?: boolean;
  tooltip?: string;
}

const Convert: React.FC<Props> = ({
  checked,
  entityKey,
  entityId,
  disabled,
  tooltip,
}) => {
  return (
    <Checkbox
      checked={checked}
      entityKey={entityKey}
      entityId={entityId}
      eventKey={CHANGE_TABLE_CELL_EVENT}
      disabled={disabled}
      tooltip={tooltip}
    />
  );
};
export default inject("store")(observer(Convert));
